import React from 'react';

const VimeoVideo = ({ entryId }) => {
  // Parse entryId in format '[videoId]/[embedId]'
  const [videoId, embedId] = entryId.split('/');

  return (
    <iframe
      src={`https://player.vimeo.com/video/${videoId}?h=${embedId}&title=0&byline=0&portrait=0&badge=0&autopause=0&dnt=1`}
      frameBorder="0"
      allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
      //referrerPolicy="strict-origin-when-cross-origin"
      style={{ width: '640px', height: '480px' }}
    />
  );
};

VimeoVideo.displayName = "VimeoVideo";

export default VimeoVideo;